export default __webpack_public_path__ + "static/media/cara.87fa49a3.png";